export async function fetchJson<T>(url: string, params: Record<string, unknown> | undefined = undefined): Promise<T> {
    let options = undefined

    if (params) {
        options = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(params),
        }
    }

    const f =  await fetch(url, options)
    return await f.json()
}
